/**
 * Validación de variables de entorno críticas — Structura Food Market.
 * En producción, lanza un error si faltan secretos obligatorios.
 * Fail-fast al iniciar — evita errores silenciosos en runtime.
 */

const DEV_FALLBACKS = new Set([
  "structura-market-dev-secret-change-me",
  "dev-secret-change-me",
  "change-me",
  "secret",
]);

function isDevFallback(value: string): boolean {
  const lower = value.toLowerCase();
  return DEV_FALLBACKS.has(lower) || lower.includes("dev-secret") || lower.includes("change-me");
}

function assertEnvVar(name: string, value: string | undefined, opts?: { minLength?: number }): void {
  if (!value || value.trim() === "") {
    throw new Error(`[env] Variable de entorno requerida no configurada: ${name}`);
  }
  if (isDevFallback(value)) {
    throw new Error(
      `[env] ${name} tiene un valor de desarrollo en producción. Configurá un secreto real en Netlify.`,
    );
  }
  if (opts?.minLength && value.trim().length < opts.minLength) {
    throw new Error(`[env] ${name} debe tener al menos ${opts.minLength} caracteres.`);
  }
}

let _checked = false;

/** Solo para tests — reset del flag de una sola ejecución. */
export function _resetCheckedForTest(): void {
  _checked = false;
}

/**
 * Verifica que las variables de entorno críticas estén configuradas en producción.
 * No-op en desarrollo/test. Ejecutar al arrancar el servidor o en el primer request.
 */
export function assertProductionSecrets(): void {
  if (_checked) return;
  _checked = true;

  const env = (typeof process !== "undefined" ? process.env.NODE_ENV : undefined) ?? "development";
  if (env !== "production") return;

  // Auth — crítico: forjabilidad de tokens
  assertEnvVar("JWT_SECRET", process.env.JWT_SECRET, { minLength: 32 });

  // DB — crítico
  assertEnvVar("DATABASE_URL", process.env.DATABASE_URL);

  // Pagos — crítico si MP está habilitado
  if (process.env.MP_ACCESS_TOKEN) {
    assertEnvVar("MP_WEBHOOK_SECRET", process.env.MP_WEBHOOK_SECRET, { minLength: 16 });
  }
}
